import { shallowMount } from "@vue/test-utils";
import Consulta from "@/views/Consulta";

describe("Consulta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Consulta);
  });

  it("Renders del component Consulta", () => {
    expect(wrapper).toBeDefined();
  });
});
